import Parent from "parentjs/controllers/header_controller.js";
export default Parent;
